export const grid = [
  0,
  196,
  195,
  197,
  200,
  202,
  203,
  204,
  206,
  207,
  151,
  152,
  157,
  156,
  159,
  169,
  168,
  167,
  166,
  165,
  0,
  194,
  193,
  198,
  199,
  201,
  209,
  208,
  205,
  177,
  150,
  153,
  154,
  155,
  158,
  160,
  161,
  162,
  163,
  164,
  104,
  102,
  101,
  103,
  105,
  106,
  107,
  108,
  109,
  110,
  111,
  112,
  113,
  114,
  115,
  116,
  117,
  118,
  119,
  0,
  0,
  252,
  0,
  0,
  253,
  184,
  183,
  182,
  129,
  130,
  131,
  132,
  133,
  134,
  135,
  137,
  138,
  139,
  0,
  0,
  0,
  251,
  0,
  191,
  187,
  185,
  186,
  181,
  121,
  123,
  145,
  144,
  142,
  140,
  136,
  127,
  128,
  0,
  0,
  0,
  0,
  250,
  192,
  190,
  188,
  178,
  179,
  180,
  120,
  122,
  147,
  146,
  143,
  141,
  124,
  125,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  189,
  0,
  0,
  172,
  171,
  173,
  174,
  175,
  176,
  170,
  126,
  0,
  0,
  0,
  0,
  0
];
